import { defineMessages } from "react-intl";
export var messages = defineMessages({
  today: {
    id: "jutro-components.widgets.inputs.DatePicker.today",
    defaultMessage: "Today"
  }
});